import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { franceRegularInvoiceSchema } from "./schema";


export const franceRegularInvoiceConfig = defineForm({
  id: "france_regular_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.FRANCE_REGULAR_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "FrancePA",
  invoiceType: "regularInvoice",
  complianceType: ComplianceDocumentType.RegularInvoice,
  requiresLegalRep: true,
  titleKey: "regular_invoice",
  complianceStandardKey: "FrancePA",
  schema: franceRegularInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  additionalOptions: {
      hiddenOptions: ["additionalTax"],
    },
  },
  omitFromPayload: ["customerCompanyAddress"],
  
});
